import { render, staticRenderFns } from "./membercard_new.vue?vue&type=template&id=e3c65186&scoped=true"
import script from "./membercard_new.vue?vue&type=script&lang=js"
export * from "./membercard_new.vue?vue&type=script&lang=js"
import style0 from "./membercard_new.vue?vue&type=style&index=0&id=e3c65186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c65186",
  null
  
)

export default component.exports